import type { IChangeFlightEligibilityClasses } from "@b2bportal/core-types";
import type { IChangeFlightEligibilityData } from "@tenant/flights";
import { DialogClose } from "@tenant/ui";

export interface IFlightExchangeIneligibleProps {
  classes?: Partial<
    IChangeFlightEligibilityClasses & {
      closeBtn: string;
    }
  >;
  copy: IChangeFlightEligibilityData["copy"];
}

export const FlightExchangeIneligible = (
  props: IFlightExchangeIneligibleProps
) => {
  const { classes, copy } = props;

  return (
    <div className={classes?.modalContent}>
      <div className={classes?.contentHeader}>
        <span className={classes?.contentTitle}>{copy.canceled.title}</span>
        <span className={classes?.contentBody}>{copy.canceled.body}</span>
      </div>
      <div className={classes?.contentActions}>
        <DialogClose className={classes?.closeBtn}>{copy.closeBtn}</DialogClose>
      </div>
    </div>
  );
};
